import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "@/components/ui/provider";

import App from "./App.tsx";
import "./index.css";
import { Theme } from "@chakra-ui/react";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://f12b7cfe29887dd9315f31f3b95a3719@o4508502092283904.ingest.us.sentry.io/4508502093529088",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/api\.flightguesser\.com/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider>
      <Theme appearance="light">
        <App />
      </Theme>
    </Provider>
  </StrictMode>
);
